import React from "react"
import Playground from "./Playground"

export default (props) => {
  return <Playground path="/sequence-diagram" {...props} />
}
